import React, {useRef} from 'react';
import FAQ from 'js/components/Taxonomies/FAQ/FAQ';
import Training from 'js/components/Templates/PostLoginPage/Training/Training';
import Welcome from 'js/components/Templates/PostLoginPage/Wellcome/Wellcome';
import VideoHome from 'js/components/Templates/PostLoginPage/VideoHome/VideoHome';
import SearchForm from 'js/containers/Pages/Search/SearchBlock/SearchForm/SearchForm';
import HomepageWrap from 'js/components/Templates/PostLoginPage/HomepageWrap/HomepageWrap';
import ManagedServicesBanner from 'js/components/Common/ManagedServicesBanner/ManagedServicesBanner';
import LastContentSlider from 'js/components/Templates/PostLoginPage/LastContentSlider/LastContentSlider';
import ExploreContentSlider from 'js/components/Templates/PostLoginPage/ExploreContentSlider/ExploreContentSlider';

const PostLoginPageTemplate = ({pageId}) => {
	const formRef = useRef(null);
	return (
		<main className="templatePostLogin" ref={formRef}>
			<HomepageWrap>
				<Welcome pageId={pageId} />
				<SearchForm headerRef={formRef} isHome={true} />
				<VideoHome pageId={pageId} />
			</HomepageWrap>
            <LastContentSlider pageId={pageId} />
            <ExploreContentSlider  pageId={pageId} />
			<Training pageId={pageId} />
			<FAQ pageId={pageId} pageType={'Page'} fieldGroupName={'PostLoginPage'} />
			<ManagedServicesBanner />
		</main>
	);
};

export default PostLoginPageTemplate;
